import { Box, Container, Typography, Divider } from '@mui/material';
import PodcastBadges from './PodcastBadges';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        py: 4,
        mt: 6
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3
          }}
        >
          {/* Podcast Badges */}
          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 2, textAlign: 'center', fontWeight: 500 }}
            >
              Listen on your favorite platform
            </Typography>
            <PodcastBadges />
          </Box>

          <Divider sx={{ width: '100%', maxWidth: 400 }} />

          {/* Copyright */}
          <Typography variant="caption" color="text.disabled" textAlign="center">
            © {currentYear} So You Can Hear Me When I'm Gone. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
